import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
 // reuse the document icon
 
const SafetyhHome = ({token}) => {

  const navigate = useNavigate();
       const handleNavigate = () => {
     const path = token ? `/safety-form?allow=${token}` : '/safety-form';
     navigate(path);
   };
  return (
    <div className="mt-10 bg-white shadow-lg rounded p-4 px-6 border-[1.5px] border-gray-100 flex flex-col justify-between">
      <div className="text-[12px]  font-semibold text-left mb-6 leading-[1.2]">
        SAFETY AND HEALTH PRIMARY AUDIT FORM
      </div>
 
      <div className="flex justify-center">
        <button
        onClick={() => handleNavigate()}
 
       
        className="bg-black text-sm text-white px-6 py-1 w-full rounded flex items-center justify-center gap-2 transition">
          <FiFileText className="text-md" />
          Fill out Form
        </button>
      </div>
    </div>
  );
};
 
export default SafetyhHome;

